<template>
  <div class="training-group-operate-log"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="timeline !== false">
      <AppScrollbar v-if="timeline && timeline.length"
                    style="height: 100%">
        <div class="log-main">
          <el-timeline>
            <el-timeline-item v-for="(item, index) in timeline"
                              :key="index"
                              :timestamp="item.createDate | formatDate"
                              type="primary"
                              placement="top">
              <div class="log-card">
                <div class="log-title">
                  <el-tag size="small" type="primary">{{item.title}}</el-tag>
                </div>
                <div class="log-content" v-if="item.content">{{item.content}}</div>
                <div class="log-operator">操作人：{{item.operatorName || '--'}}</div>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </AppScrollbar>
      <Hint v-else>
        <div>暂无操作记录</div>
      </Hint>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>操作记录加载失败</div>
        <el-button type="text"
                   @click="loadTimeline">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../elements/AppScrollbar'
import Hint from '../../../../../../elements/Hint'
export default {
  name: 'TrainingGroupOperateLog',
  components: {
    AppScrollbar,
    Hint
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    extraParams: Object,
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      timeline: false
    }
  },
  filters: {
    formatDate (val) {
      if (!val) return '--'
      if (typeof val === 'string') return val
      let date = new Date(val)
      let year = date.getFullYear()
      let month = String(date.getMonth() + 1).padStart(2, '0')
      let day = String(date.getDate()).padStart(2, '0')
      let hours = String(date.getHours()).padStart(2, '0')
      let minutes = String(date.getMinutes()).padStart(2, '0')
      let seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  },
  methods: {
    loadTimeline () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/training/group/operateLogTimeline',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          postId: this.rowData.id
        }, this.extraParams))
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.timeline = response.data['data'] || []
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadTimeline()
  },
  watch: {
    visible: function (val) {
      if (val) {
        this.loadTimeline()
      }
    }
  }
}
</script>

<style lang="scss">
.training-group-operate-log {
  width: 600px;
  height: 100%;
  .log-main {
    padding: 15px;
    .el-timeline {
      padding-left: 0;
      .el-timeline-item {
        .el-timeline-item__wrapper {
          .el-timeline-item__timestamp {
            color: #606266;
            font-size: 12px;
            font-weight: bold;
          }
          .el-timeline-item__content {
            .log-card {
              margin-top: 10px;
              margin-right: 15px;
              padding: 12px;
              background-color: #fff;
              border-radius: 5px;
              box-shadow: 0 1px 5px rgba(0,0,0,.1);
              .log-title {
                font-size: 14px;
                font-weight: bold;
                color: #303133;
              }
              .log-content {
                margin-top: 8px;
                font-size: 13px;
                color: #606266;
                &:empty {
                  display: none;
                }
              }
              .log-operator {
                margin-top: 8px;
                color: #909399;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
